module.exports = __webpack_public_path__ + "img/im2.8d51e8b5.png";